import PaginatedList from "#root/components/paginated-list";
import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { cloudScheduleTaskCollection } from "#root/schema/platform/cloudschedule";
import PageLayout from "./layout";

export default function TaskListPage(): ReactNode {
  return (
    <PageLayout title="CloudSchedule - Tasks">
      <PaginatedList title="CloudSchedule Tasks" collection={cloudScheduleTaskCollection} refresh={1000}>
        {({ rows }) => (
          <table>
            <thead>
            <tr>
              <th>Name</th>
              <th>Last Started</th>
              <th>Last Finished</th>
              <th>Last Status</th>
              <th>Last Output</th>
              <th>Action</th>
            </tr>
            </thead>
            <tbody>
            {rows.map(task => (
              <tr key={task.id} className={task.lastStarted && !task.lastFinished ? "highlight" : task.lastStatus === "complete" ? "" : "error"}>
                <td>{task.name}</td>
                <td style={{ whiteSpace: "nowrap" }}>{task.lastStarted ? new Date(task.lastStarted).toLocaleString() : "Hasn't Run"}</td>
                <td style={{ whiteSpace: "nowrap" }}>{task.lastFinished ? new Date(task.lastFinished).toLocaleString() : "Running"}</td>
                <td>{task.lastStatus}</td>
                <td>{task.lastOutput}</td>
                <td>
                  <Link to={`/admin/platform/cloudschedule/${task.id}`}>Recent Jobs</Link>
                  &middot; <Link to={`/admin/platform/cloudschedule/${task.id}/edit`}>Edit Task</Link>
                </td>
              </tr>
            ))}
            </tbody>
          </table>
        )}
      </PaginatedList>
    </PageLayout>
  );
}
